import React, { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import Wrapper from './styled';
import BooleanField from './BooleanField';
import { useSelector, useDispatch } from 'react-redux';
import { SelectShowCloudAgents, selectTriggerMaxSeverity, selectTriggerMinSeverity, selectTriggerResolveHostname } from 'store/Agents/selectors';
import { setResolveHostname, setResolveHostnameInDetail, setSeverityRange, setSeverityRangeInDetail } from 'store/Agents/actions';
import { useIntl } from 'react-intl';
import SeverityRange from 'Common/Components/SeverityRange';
import { STEP_VALUES } from 'Common/Components/SeverityRange/constants';

const ExecutionParams = ({
  currentTool,
  disabled,
  runStatusLog,
  cloudScheduler,
  onChange
}) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const isCloudAgent = useSelector(SelectShowCloudAgents);
  const cloud = isCloudAgent || cloudScheduler;
  const minSeverityParam = isCloudAgent ? 'parameters_data.min_severity' : 'min_severity';

  const maxSeverityParam = isCloudAgent ? 'parameters_data.max_severity' : 'max_severity';
  const resolveHostNameParam = isCloudAgent ? 'parameters_data.resolve_hostname' : 'resolve_hostname';
  const initialMinSeverity = STEP_VALUES.find((sev) => sev.parsedSeverity === get(currentTool, minSeverityParam, 'unclassified')?.toLowerCase()) || STEP_VALUES[0];
  const initialMaxSeverity = STEP_VALUES.find((sev) => sev.parsedSeverity === get(currentTool, maxSeverityParam, 'critical')?.toLowerCase()) || STEP_VALUES[5];
  const initialResolveHostname = get(currentTool, resolveHostNameParam, false);
  const minSeverity = useSelector((state) => selectTriggerMinSeverity(state, get(currentTool, 'id', 0)));
  const maxSeverity = useSelector((state) => selectTriggerMaxSeverity(state, get(currentTool, 'id', 0)));
  const resolveHostname = useSelector((state) => selectTriggerResolveHostname(state, get(currentTool, 'id', 0)));
  const resolveHostnameLabel = intl.formatMessage({ id: 'agents.triggerAgent.resolveHostnames' });
  const defaultMinSeverity = runStatusLog || isCloudAgent ? initialMinSeverity : STEP_VALUES.find((sev) => sev.parsedSeverity === minSeverity?.toLowerCase());
  const defaultMaxSeverity = runStatusLog || isCloudAgent ? initialMaxSeverity : STEP_VALUES.find((sev) => sev.parsedSeverity === maxSeverity?.toLowerCase());
  const defaultResolveHostName = runStatusLog || isCloudAgent ? initialResolveHostname : resolveHostname;

  useEffect(() => {
    if (runStatusLog) {
      dispatch(setSeverityRange({
        min: { value: initialMinSeverity?.value, severity: initialMinSeverity?.parsedSeverity },
        max: { value: initialMaxSeverity?.value, severity: initialMaxSeverity?.parsedSeverity }
      }));
      dispatch(setResolveHostname(initialResolveHostname));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const onChangeResolveHostname = (checked, currentTool) => {
    if (onChange) onChange();
    if (runStatusLog || cloud) dispatch(setResolveHostname(checked));
    else dispatch(setResolveHostnameInDetail(checked, currentTool));
  };

  const handleChangeSeverity = (range) => {
    if (onChange) onChange();
    const min = STEP_VALUES.find((sev) => sev.value === range[0]);
    const max = STEP_VALUES.find((sev) => sev.value === range[1]);
    if (runStatusLog || cloud) {
      dispatch(setSeverityRange({
        min: { value: min.value, severity: min.parsedSeverity },
        max: { value: max.value, severity: max.parsedSeverity }
      }, currentTool));
    } else {
      dispatch(setSeverityRangeInDetail(min.parsedSeverity, max.parsedSeverity, currentTool));
    }
  };

  if (isEmpty(currentTool)) return null;
  return (
    <Wrapper>
      <SeverityRange
        defaultMin= { defaultMinSeverity?.value }
        defaultMax={ defaultMaxSeverity?.value }
        onChange={ handleChangeSeverity }
        isDisabled={ disabled }
        width="86%"
      />
      <BooleanField defaultValue={ defaultResolveHostName } param={ resolveHostnameLabel } onChange={ (checked) => onChangeResolveHostname(checked, currentTool) } disabled={ disabled } />
    </Wrapper>
  );
};

export default ExecutionParams;
